module.exports = __webpack_public_path__ + "static/IMG-9-e2c684c3d558678de21a3334d8623d72.jpg";